export default __webpack_public_path__ + "images/db-logos/rds_mysql.png";